import React from "react";
import { motion } from "framer-motion";
import { Brain, Bot, Globe, Smartphone, Rocket, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: Brain,
    title: "AI Apps",
    desc: "Full-stack AI products like jananibachpan.com — chat, RAG, recommendations, generation. Ready in a week.",
    span: "md:col-span-8",
    tall: true,
    accent: "cyan",
    image:
      "https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    icon: Bot,
    title: "AI Agents",
    desc: "Autonomous agents that book, research, support & automate workflows end-to-end.",
    span: "md:col-span-4",
    accent: "yellow",
  },
  {
    icon: Globe,
    title: "Websites",
    desc: "Marketing sites & landing pages, designed and shipped in a single day.",
    span: "md:col-span-4",
    accent: "magenta",
  },
  {
    icon: Smartphone,
    title: "ACE AI Apps",
    desc: "Domain-specific intelligent apps tailored to your business — fast, lean and deployable.",
    span: "md:col-span-4",
    accent: "cyan",
  },
  {
    icon: Rocket,
    title: "1-Click Deploy",
    desc: "Every build ships deployment-ready. Push live in minutes, scale when you grow.",
    span: "md:col-span-4",
    accent: "yellow",
  },
];

const accentMap = {
  cyan: "text-neon-cyan",
  yellow: "text-neon-yellow",
  magenta: "text-neon-magenta",
};

export default function Services() {
  return (
    <section id="services" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-neon-cyan mb-3">// what we build</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter">
            One studio. Every kind of <span className="text-neon-cyan">AI software.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`glow-border relative overflow-hidden rounded-2xl border border-neon-cyan/15 bg-surface p-7 ${
                  s.span
                } ${s.tall ? "md:row-span-2 min-h-[280px]" : "min-h-[200px]"}`}
              >
                {s.image && (
                  <>
                    <img src={s.image} alt={`${s.title} — vonmal AI service`} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-20" />
                    <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/80 to-transparent" />
                  </>
                )}
                <div className="relative flex flex-col h-full">
                  <Icon size={32} className={accentMap[s.accent]} strokeWidth={1.5} />
                  <h3 className="mt-5 text-xl font-bold tracking-tight flex items-center gap-2">
                    {s.title}
                    <ArrowUpRight size={18} className="text-white/30" />
                  </h3>
                  <p className="mt-2 text-sm text-white/55 leading-relaxed max-w-md">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
